import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';

import ContentEdit, { Actions, Header, Detail, Side } from './ContentEdit';
import {
  ReceiptsFilter,
  ReceiptsCardsSide,
  ReceiptsCards,
  ReceiptDialog,
  ReceiptDialog2,
} from './Receipts';

const styles = theme => ({
  root: {
    marginTop: theme.spacing.unit,
    marginRight: theme.spacing.unit*4,
    marginBottom: theme.spacing.unit*4,
    marginLeft: theme.spacing.unit*4,
  },
});

class ReceiptsPage extends Component {
  constructor(props){
    super(props);

    this.state = {
      showDialog: false,
      dialogType: undefined,
      receipt: undefined,
    };
  }

  render() {
    const { classes, theme } = this.props;
    const { showDialog, dialogType, receipt } = this.state;
    return(
      <div className={classes.root}>
        {showDialog &&
          <ReceiptDialog2
            show={showDialog}
            type={dialogType}
            receiptData={receipt}
            handleClose={() => this.setState({showDialog: false, dialogType: undefined, receipt: undefined})}
          />
        }
        <ContentEdit>
          <Header theme={theme}>
            <ReceiptsFilter handleAdd={() => this.setState({showDialog: true, dialogType: "add", receipt: undefined})} />
          </Header>
          <Detail theme={theme}>
            <ReceiptsCards
              handleEdit={(receipt) => {
                this.setState({showDialog: true, dialogType: "edit", receipt: receipt})}
              }/>
          </Detail>
          <Side theme={theme}>
            <ReceiptsCardsSide />
          </Side>
        </ContentEdit>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ReceiptsPage);



// WEBPACK FOOTER //
// ./src/components/admin/ReceiptsPage.jsx